<template>
  <DomainVerificationSso />
</template>

<script setup lang="ts">
import { useDomainVerificationsContext } from '@/composables/deepadmin/use-domain-verifications-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import DomainVerificationSso from '@/components/deepadmin/domain-verifications/DomainVerificationSso.vue'

definePage({
  meta: {
    breadcrumbLabelKey:
      'navigation.organization.settings.security.domain_verifications.sso_configuration',
  },
})

const { selectedDomain } = useDomainVerificationsContext()

usePageAccess(computed(() => !selectedDomain.value?.verifiedAt))
</script>
